module.exports = __webpack_public_path__ + "static/img/Ben_Cunnington_desktop.f579e28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ben_Cunnington_desktop.jpg
// module id = oXJ5
// module chunks = 0